export default {
  header: {
    title: 'E-Mail-Adresse bestätigen',
    text: 'Wir haben eine Bestätigungs-E-Mail an {email} gesendet. Bitte überprüfen Sie Ihren Posteingang und bestätigen Sie Ihre E-Mail-Adresse.',
  },
  form: {
    action: 'Bestätigungs-E-Mail erneut senden',
  },
}
